

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const MENTORREQUIREMENTPOST= createAsyncThunk(
  "MentorRequirementPost/MentorRequirementPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const MentorRequirementPostSlice = createSlice({
  name: "MentorRequirementPostSlice",
  initialState: {
    MentorRequirementPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfMentorRequirementPost: (state) => {
        state.MentorRequirementPost.loading = false
        state.MentorRequirementPost.error = false
        state.MentorRequirementPost.data = []
        state.MentorRequirementPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MENTORREQUIREMENTPOST.fulfilled, (state, action) => {
      state.MentorRequirementPost = {
        ...state.MentorRequirementPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MENTORREQUIREMENTPOST.pending, (state, action) => {
      state.MentorRequirementPost = {
        ...state.MentorRequirementPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MENTORREQUIREMENTPOST.rejected, (state, action) => {
      state.MentorRequirementPost = {
        ...state.MentorRequirementPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const MentorRequirementPostAction = {
    MENTORREQUIREMENTPOST,
};

export { MentorRequirementPostAction };
export default MentorRequirementPostSlice.reducer;
export const {setInitialStateOfMentorRequirementPost} = MentorRequirementPostSlice.actions
